export interface WithdrawalRequestLike {
  /** 新スキーマ（PrepaidTransferRequest 親）: pending / success / partial_success / failed */
  parent_status?: string;
  /** 旧スキーマ後方互換 */
  request_status?: string;
  status?: string;
}

const TERMINAL_WITHDRAWAL_STATUSES = new Set([
  'accepted',
  'rejected',
  'completed',
  'failed',
  'cancelled',
  'normal_end',
  'success',
  'partial_success',
  '正常終了',
  '処理失敗',
]);

const PENDING_WITHDRAWAL_STATUSES = new Set([
  'pending',
  'processing',
]);

export const hasPendingWithdrawalRequest = (requests: WithdrawalRequestLike[]): boolean => {
  return requests.some((request) => {
    const parentStatus = request.parent_status?.trim();
    if (parentStatus) {
      return PENDING_WITHDRAWAL_STATUSES.has(parentStatus);
    }

    // 旧スキーマ後方互換
    const requestStatus = request.request_status?.trim();
    const status = request.status?.trim();

    if (requestStatus === '受付失敗' || status === 'rejected') {
      return false;
    }

    if (status && TERMINAL_WITHDRAWAL_STATUSES.has(status)) {
      return false;
    }

    return Boolean(status && PENDING_WITHDRAWAL_STATUSES.has(status));
  });
};

export const getWithdrawalStatusLabel = (request: WithdrawalRequestLike): string => {
  const parentStatus = request.parent_status?.trim();
  if (parentStatus) {
    if (parentStatus === 'pending') return '申請中';
    if (parentStatus === 'success') return '成功';
    if (parentStatus === 'partial_success') return '一部成功';
    if (parentStatus === 'failed') return '失敗';
  }

  // 旧スキーマ後方互換
  const requestStatus = request.request_status?.trim();
  const status = request.status?.trim();

  if (requestStatus === '受付失敗' || status === 'rejected' || status === '処理失敗' || status === 'failed') {
    return '受付失敗';
  }

  if (status && PENDING_WITHDRAWAL_STATUSES.has(status)) {
    return '申請中';
  }

  if (requestStatus === '受付成功' || (status && TERMINAL_WITHDRAWAL_STATUSES.has(status))) {
    return '申請受付済み';
  }

  return '申請中';
};